import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Button, Input, InputGroup, InputGroupText, Tooltip } from "reactstrap";
import styles from "./ResourcePage.module.scss";
import ModalDialog from "../../components/common/Modal/Modal";
import useModal from "../../components/Hooks/useModal";
import PositionForm from "../../components/Position/AddPositionForm";
import { AiOutlinePlus } from "react-icons/ai";
import DataTable from "react-data-table-component";
import tableCustomStyles from "../../components/common/CustomeStyle";
import { resourceService } from "../../services";
import { Search } from "react-bootstrap-icons";
import { CiFilter } from "react-icons/ci";
import { BsExclamation } from "react-icons/bs";
import Popover from "../../components/common/Popover/Popover";
import ActionMenu from "../../components/common/ActionMenu/ActionMenu";
import { jobProfileActions, ResourceActions } from "../../actions";
import { formatMoney, isEmptyObject, updateURLParameter } from "../../helpers";
import ConfirmDialog from "../../components/common/ConfirmDialog/ConfirmDialog";
import sortIcon from "../../resources/images/sort.svg";
import Loader from "../../components/common/Loader/Loader";
import NoDataFond from "../../components/common/noDatafound/noDataPage";
import { object, string } from "yup";
import { FormikWizard } from "formik-wizard-form";
import Steps from "../../components/Resources/Steps";
import ResourceFilter from "../../components/ResourceFilter/ResourceFilter";
import { masterDataActions } from "../../actions/masterData.action";
import ResourceForm from "../../components/ResourceUpdateForm/ResourceUpdateForm";
import Form from "../../components/common/Form/From";
import moment from "moment";
import { toast } from "react-toastify";
import UserRoleForm from "../../components/Resources/UserRole";
import ExtendResourceRow from "../../components/ExtendRow/ExtendResourceRow";
import Avatar from "react-avatar";
import ResourceDeatils from "../../components/DetailComponent/ResourceDetail";
import { masterData } from "../../reducers/masterData.reducer";
import { authActions } from "../../actions/auth.actions";

function ResourcePage() {
  const { toggle: addPositionToggle, visible: positionVisible } = useModal();
  let { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
  let { toggle: ConfirmStatusToggle, visible: ConfirmStatusModal } = useModal();
  const { toggle: roleToggle, visible: roleModel } = useModal();
  const { toggle: resourceDetailsToggle, visible: resourceDetailModel } = useModal();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const [searchParams] = useSearchParams();
  const [pending, setPending] = useState(true);
  const [profileData, setProfileData] = useState({});
  const [filterText, setFilterText] = useState("");
  const [page, setPage] = useState(1);
  const [submited, setSubmited] = useState(false);
  const [channelPopover, setChannelPopover] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [activeData, setActiveData] = useState(null)
  const [roleData, setRoleData] = useState(null);
  const [sort, setSort] = useState("id");
  const [resourceId, setResourceId] = useState(null);
  const [sortType, setSortType] = useState("desc");
  const [filterData, setFilterData] = useState(null);
  const departmentArr = useSelector((state) => state?.masterData?.department)
  const designationArr = useSelector((state) => state?.masterData?.designation)
  const [activeResource, setActiveResource] = useState(null)
  const countPerPage = 10;
  const [initialValues, setInitialValues] = useState({
    email: "",
    role: "",
    name: "",
    lastname: "",
    department: "",
    designation: "",
    country: "IN",
    phone: "",
    experienceYear: "",
    experienceMonth: "",
    dateOfJoining: "",
    dob: "",
    skills: "",
    userId: ""
  });

  const [rolInitialValues, setRoleInitialValues] = useState({
    role: ""
  })

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.authentication.user);

  const columns = [
    {
      name: "Name",
      selector: (row) => {
        let name = row?.name;
        let lastName = row?.lastName
        if (row?.lastName !== "") {
          name += ` ${row?.lastName}`
        }
        return (
          <div className="NameGroup header-link"
            onClick={() => {
              setActiveResource(row);
              resourceDetailsToggle();
            }}>
            {row?.avtar?.url ?
              <Avatar
                className={styles.commentAvt}
                facebook-id="invalidfacebookusername"
                src={row?.avtar?.url}
                size="30"
                round={true}
              /> : <Avatar
                className={styles.commentAvt}
                name={name+ " " +lastName}
                maxInitials={2}
                size="30"
                round={true}
              />
            }
            <span className="name-text"> {name}</span>
          </div>
        );
      },
      sortable: true,
      sortField: "name",
      grow: 2
    },
    {
      name: "Department",
      selector: (row) => row?.department,
      sortable: true,
      sortField: "department",
      style: {
        cursor: "default",
      },
    },
    {
      name: "Designation",
      selector: (row) => row?.designation,
      sortable: true,
      sortField: "designation",
      grow: 2,
      style: {
        cursor: "default",
      },
    },
    // {
    //   name: "Skills",
    //   selector: (row) => {
    //     return(
    //       <div className="header-link">
    //         <span title={row?.skills}>{row?.skills}</span>
    //       </div>
    //     )
    //   },
    //   sortable: false,
    //   style: {
    //     cursor: "default",
    //   },
    // },
    {
      name: <>Previous <br /> Experience</>,
      selector: (row) => row?.experience,
      sortable: true,
      sortField: "experience",
      style: {
        cursor: "default",

      },
    },
    {
      name: <>Company <br /> Experience</>,
      selector: (row) => row?.gexperience?.year || row?.gexperience?.months ? row?.gexperience?.year + " Y " + row?.gexperience?.months + " M" : "",
      sortable: true,
      sortField: "dateOfJoining",
      style: {
        cursor: "default",
      },
    },
    {
      cell: (row) => (
        row?.isEditable && (
          <ActionMenu
            size="small"
            row={row}
            type="resource"
            setEditedData={setEditedData}
            setDeleteId={setDeleteId}
            setActiveData={setActiveData}
            setRoleData={setRoleData}
          />
        )

      ),
      allowOverflow: true,
      width: "56px",
    },
  ]

  // useEffect(() => {
  //   if (user && user?.userRole === 4) {
  //     navigate("/applicants");
  //   }
  // }, [user]);


  useEffect(() => {
    dispatch(masterDataActions.getDepartments())
    dispatch(masterDataActions.getDesignationBydepartment('all'))
  }, [])

  useEffect(() => {
    if (positionVisible) {
      dispatch(masterDataActions.getDepartments())
      dispatch(masterDataActions.getSkills())
      dispatch(masterDataActions.getDesignation())
    } else {
      resetVal();
    }

  }, [positionVisible])

  useEffect(() => {
    setResourceId(searchParams.get("resourceId"));
    if (searchParams.get("resourceId")) {
      resourceDetailsToggle()
      getProfileData();
      setActiveResource(profileData);
    }
  }, [])

  const getRequestParams = (
    filterText,
    page,
    pageSize,
    sort,
    sortType,
    filterData,
    resourceId
  ) => {
    let params = {};

    if (filterText) {
      params["name"] = filterText;
    }

    if (page) {
      params["page"] = page;
      params['platform'] = 'ats'
    }

    if (pageSize) {
      params["page_size"] = pageSize;
    }

    if (sort) {
      params["sort"] = sort;
    }

    if (sortType) {
      params["sort_type"] = sortType;
    }
    if (resourceId) {
      params["resourceId"] = resourceId;
    }

    if (!isEmptyObject(filterData)) {
      params = { ...params, ...filterData };
    }

    return params;
  };

  const getProfileData = async () => {
    let query = await getRequestParams(
      filterText,
      page,
      countPerPage,
      sort,
      sortType,
      filterData,
      resourceId
    );
    if (!positionVisible) {
      setPending(true);
    }
    await resourceService
      .getAllResources(query)
      .then((res) => {
        // if (query !== undefined) {
        //   window.history.replaceState(
        //     "",
        //     "",
        //     updateURLParameter(window.location.href, new URLSearchParams(query))
        //   );
        // }
        // const desigArr = designationArr?.map((ele)=>ele.name)
        // const depArr = departmentArr.map((ele)=>ele.name)
        // let resArr = []
        // res.results.forEach((ele) => {
        //     let newObj = {}
        //       newObj = ele
        //       if(!desigArr.includes(newObj.designation)){
        //         newObj.designation = null
        //       }
        //       if(!depArr.includes(newObj.department)){
        //         newObj.department = null
        //       }
        //       resArr.push(newObj)
        // });
        // res.results = resArr
        // setProfileData({
        //   page:res.page,
        //   total:res.total,
        //   results:resArr
        // });
        setProfileData(res);
        setPending(false);
      })
      .catch((e) => {
        setProfileData({});
        setPending(false);
      });
  };

  const handleSort = async (column, sortDirection) => {
    if (column?.sortField) {
      setSort(column?.sortField);
      setSortType(sortDirection);
    }
  };


  useEffect(() => {
    getProfileData();
  }, [page, sort, sortType, filterData, filterText, location, designationArr?.length, departmentArr?.length]);


  useEffect(() => {
    if (editedData !== null && editedData?.userId) {
      setInitialValues({
        email: editedData?.email,
        role: editedData?.role,
        name: editedData?.name,
        lastname: editedData?.lastName,
        department: editedData?.department,
        designation: editedData?.designation,
        country: editedData?.country ? editedData?.country : "IN",
        phone: editedData?.phone,
        experienceYear: editedData?.experienceYear,
        experienceMonth: editedData?.experienceMonth,
        dateOfJoining: editedData?.dateOfJoining ? new Date(editedData?.dateOfJoining) : "",
        dob: editedData?.dob ? new Date(editedData?.dob) : "",
        skills: editedData?.skills,
        userId: editedData?.userId
      });
      addPositionToggle();
    }
  }, [editedData]);


  useEffect(() => {
    if (deleteId !== null) {
      ConfirmToggle();
    }
  }, [deleteId]);

  useEffect(() => {
    if (activeData !== null) {
      ConfirmStatusToggle()
    }
  }, [activeData])

  useEffect(() => {
    if (roleData !== null) {
      setRoleInitialValues({ role: roleData?.role })
      roleToggle()
    }
  }, [roleData])

  const handleSubmit = (values) => {
    const button = document.getElementById('main-from-button');
    if (button) {
      button.disabled = true;
    }
    if (values) {
      dispatch(ResourceActions.createUser({ email: values.email, atsRole: values.role })).then((res) => {

        if (res?.data) {
          values.userId = res?.data?.id;
          if (values?.experienceYear && values?.experienceMonth) {
            values.experience = values?.experienceYear + "." + values?.experienceMonth
          }
          dispatch(ResourceActions.createResource(values)).then((rs) => {
            if (rs) {
              resetVal();
              getProfileData();
              addPositionToggle();
            }
          })
        }
      })
    }
  };

  const handleUpdateSubmit = (values) => {
    if (values) {
      if (values?.experienceYear || values?.experienceMonth) {
        values.experience = values?.experienceYear + "." + values?.experienceMonth
      }
      dispatch(ResourceActions.updateResource(values, values?.userId)).then((rs) => {
        if (rs) {
          resetVal();
          getProfileData();
          if (values?.userId === user?.userId) {
            dispatch(authActions.getProfile())
          }
          addPositionToggle();
        }
      })
    }
  };


  const resetVal = () => {
    setInitialValues({
      email: "",
      role: "",
      name: "",
      lastname: "",
      department: "",
      designation: "",
      country: "IN",
      phone: "",
      experienceYear: "",
      experienceMonth: "",
      dateOfJoining: "",
      dob: "",
      skills: "",
      userId: ""
    });
    setEditedData(null);
    setDeleteId(null);
    setActiveData(null)
    setRoleData(null)
  };

  const renderForm = (errors, touched) => {
    return (
      <ResourceForm
        errors={errors}
        touched={touched}
        submited={submited}
        editedData={editedData}
      />
    );
  };


  const renderRoleForm = (errors, touched) => {
    return (
      <UserRoleForm
        errors={errors}
        touched={touched}
        loderPart={submited}
        editedData={roleData}
      />
    );
  };

  const handleRoleSubmit = (values) => {
    if (values && roleData?.userId) {
      dispatch(ResourceActions.updateResource(values, roleData?.userId)).then((rs) => {
        if (rs) {
          resetVal();
          getProfileData();
          roleToggle();
        }
      })
    }
  }


  const deleteResource = (id) => {
    if (id) {
      dispatch(ResourceActions.updateResourceStatus({ status: 0 }, id));
      resetVal();
      ConfirmToggle();
      getProfileData();
    }
  };

  const ChangeStatus = async () => {
    if (activeData?.userId) {
      await resourceService.resourceStatusChange({ status: activeData?.status ? 0 : 1 }, activeData?.userId).then((res) => {
        toast.success("Status updated")
        resetVal();
        ConfirmStatusToggle();
        getProfileData();
      }).catch((e) => {
        toast.error(e)
      })
    }
  }

  const hangleFilterOption = (data) => {
    if (!isEmptyObject(data)) {
      setFilterData(data);
      setPage(1);
    } else {
      setPage(1);
      setFilterData(null);
    }
  };

  const searchChange = (e) => {
    setFilterText(e?.target?.value);
    setPage(1);
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="main-header-buttons">
        <div className={styles.buttonPart}>
          <Button
            type="button"
            onClick={() => addPositionToggle()}
            className={styles.brandButton}
          >
            <AiOutlinePlus /> Add Resource
          </Button>
        </div>
        <div>
          <InputGroup className="my-2 my-md-0">
            <InputGroupText className="search-addon">
              <Search />{" "}
            </InputGroupText>
            <Input
              className="search-input"
              placeholder="Search"
              value={filterText}
              onChange={(e) => {
                searchChange(e);
              }}
            />
            <Button type="button" className={`btn ${filterData?.celebration || filterData?.status ? 'filter-btn-active' : 'filter-btn'}`} id="filter-button">
              <CiFilter />
              Filter
            </Button>
          </InputGroup>
        </div>
      </div>
    );
  }, [filterText, filterData]);

  return (
    <div className={styles.ResourceMain}>
      <div className="mt-3">
        {/* {profileData?.data_present ? ( */}
        <>
          <div className="reasourceTable">
            <DataTable
              columns={columns}
              data={profileData?.results}
              customStyles={tableCustomStyles}
              highlightOnHover
              pointerOnHover
              striped
              pagination
              paginationServer
              paginationTotalRows={profileData?.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              progressPending={pending}
              progressComponent={
                <Loader
                  height={50}
                  width={50}
                  color={"#5382ba"}
                  center={true}
                />
              }
              onChangePage={(page) => setPage(page)}
              onSort={handleSort}
              sortServer
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
              persistTableHead
              responsive
              sortIcon={<img src={sortIcon} alt="sort" />}
            // expandableRows
            // expandableRowExpanded={(row) => row.defaultExpanded}
            // expandableRowsComponent={ExtendResourceRow}
            />
          </div>

          <Popover
            popoverOpen={channelPopover}
            target="filter-button"
            handleToggle={() => {
              setChannelPopover(!channelPopover);
            }}
            title={""}
            pbody={
              <ResourceFilter
                hangleFilterOption={hangleFilterOption}
                setChannelPopover={setChannelPopover}
                filterData={filterData}
              />

            }
            classname="report-popover"
            placement="bottom-end"
          />
        </>
        {/* ) : (
          <div>
            <div className="main-header-buttons">
              <div className={styles.buttonPart}>
                <Button
                  type="button"
                  onClick={() => addPositionToggle()}
                  className={styles.brandButton}
                >
                  <AiOutlinePlus /> Add
                </Button>
              </div>
            </div>
            {profileData?.data_present === false ? (
              <NoDataFond />
            ) : (
              <Loader color={"#5382ba"} />
            )}
          </div>
        )} */}
      </div>
      <ModalDialog
        toggle={addPositionToggle}
        title={`${editedData !== null ? "Update" : "Add"} Resource`}
        visible={positionVisible}
        size="md"
        bodyClass="p-0"
      >
        {editedData !== null ?
          <Form
            initialValues={initialValues}
            validationSchema={object().shape({
              name: string().required().max(15),
              lastname: string().max(15),
              department: string().required("Department is required").nullable(),
              designation: string().required("Designation is required").nullable(),
              phone: string().required("Phone Number is required").nullable(),
            })}
            handleSubmit={handleUpdateSubmit}
            renderForm={renderForm}
          /> :
          <FormikWizard
            initialValues={initialValues}
            onSubmit={(values) => handleSubmit(values)}
            validateOnNext
            activeStepIndex={0}
            steps={Steps}
          >
            {({
              renderComponent,
              handlePrev,
              handleNext,
              isNextDisabled,
              isPrevDisabled,
              isLastStep,
            }) => (
              <>
                {renderComponent()}
                {!isPrevDisabled ?
                  <Button
                    type="button"
                    onClick={handlePrev}
                    disabled={isPrevDisabled}
                    className={styles.brandButton}
                    id="prev-form-button"
                  >
                    Previous
                  </Button> : ""
                }

                <Button
                  type="button"
                  onClick={handleNext}
                  disabled={isNextDisabled}
                  className="main-from-button"
                  id='main-from-button'
                >
                  {isLastStep ? "Submit" : "Next"}
                </Button>
              </>
            )}
          </FormikWizard>
        }

      </ModalDialog>
      <ModalDialog
        toggle={resourceDetailsToggle}
        title={`Resource Details`}
        visible={resourceDetailModel}
        size="lg"
        bodyClass="p-0"
      >
        <ResourceDeatils data={activeResource} />
      </ModalDialog>

      <ModalDialog
        toggle={roleToggle}
        title={`Change Role`}
        visible={roleModel}
        size="md"
        bodyClass="p-0"
      >

        <Form
          initialValues={rolInitialValues}
          handleSubmit={handleRoleSubmit}
          renderForm={renderRoleForm}
        />

      </ModalDialog>

      <ConfirmDialog
        visible={ConfirmModal}
        toggle={ConfirmToggle}
        title="Are you sure you want to delete the resource?"
        activeBtnClick={() => {
          deleteResource(deleteId);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>
      <ConfirmDialog
        visible={ConfirmStatusModal}
        toggle={ConfirmStatusToggle}
        title={` Are you sure you want to change status mark as ${activeData && !activeData?.status ? 'Active' : 'Inactive'}?`}
        activeBtnClick={() => {
          ChangeStatus();
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>

    </div>
  );
}

export default ResourcePage;
